export default function ({ $config }) {
  return {
    httpEndpoint: $config.apiServerEndpoint,
    browserHttpEndpoint: $config.apiEndpoint,
    persisting: true,
  }
}
